var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerLecturer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:5.78px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.53,92l0-14.84c0-5.61,0-9.67,1.12-10.51,1.58-1.19,7.46-1.19,15.6-1.19h33.15c8.14,0,14.8,0,16.38,1.19,1.12.84,1.12,4.9,1.12,10.49l0,14.18"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108.77,
    cy: 35.34,
    r: 17.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.77,
    y: 92.5,
    width: 134.51,
    height: 20.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "148.62 113.58 148.62 200.27 69.17 200.27 69.17 113.58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 88.8,
    y1: 79.5,
    x2: 88.8,
    y2: 90.84
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.97,
    y1: 79.5,
    x2: 128.97,
    y2: 90.84
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "52.59 92.17 52.59 59.84 63.59 51.84"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 69.72,
    cy: 47.96,
    r: 7.22
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerLecturer);
export default __webpack_public_path__ + "static/media/SPEAKER_LECTURER.862313caed0d07284186c387975b27f7.svg";
export { ForwardRef as ReactComponent };